// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PROFILE_username_BLOCKED_BY_USER = "U\u017eivatelka %(username)s u\u017e nem\u00e1 \u00fa\u010det na Modr\u00e9m kon\u00edku. K tomuto kroku se rozhodla a \u00fa\u010det si zru\u0161ila sama.";
